module.exports = __webpack_public_path__ + "static/media/cabinetmedicalseignosse2018-3.172df68f.jpg";